import React from "react";

export default () => <>user profile</>;
